/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

function Navigation(props) {
  const { currentPage, pageCount } = props;

  const loc = useLocation();
  const [base] = loc.pathname.split('/item/');
  const nextLoc = `${base}/item/${Math.min(currentPage + 1, pageCount - 1)}`;
  const prevLoc = `${base}/item/${Math.max(currentPage - 1, 0)}`;

  // Calculate the page numbers that we want to show
  const range = 2;
  const lowest = Math.max(currentPage - range, 0);
  const highest = Math.min(currentPage + range, pageCount);
  let navPages = [0, pageCount - 1];
  for (let index = lowest; index < highest; index += 1) {
    navPages.push(index);
  }
  navPages = [...new Set(navPages)].sort((a, b) => a - b);
  const showStartDots = navPages[1] > 1;
  const showEndDots =
    navPages[navPages.length - 1] > navPages[navPages.length - 2] + 1;

  return (
    <div className="flex gap-x-8 justify-center m-auto">
      {/* Go back */}
      <Link to={prevLoc}>
        <ChevronLeftIcon className="w-8 h-w-8 text-sky" />
      </Link>

      {/* Pages */}
      <ul className="flex justify-center">
        {navPages.map((pageNumber, index) => {
          const selected = pageNumber === currentPage;
          return (
            <li key={pageNumber} className="flex">
              {index === 1 && showStartDots ? (
                <p className="text-grey-medium_light mt-2">...</p>
              ) : null}
              <button type="button">
                <p
                  className={clsx(
                    'text-md  px-4 py-2 align-bottom',
                    selected
                      ? 'bg-sky text-white rounded-md'
                      : 'text-grey-medium_light'
                  )}
                >
                  {pageNumber + 1}
                </p>
              </button>
              {showEndDots && index === navPages.length - 2 ? (
                <p className="text-grey-medium_light mt-2">...</p>
              ) : null}
            </li>
          );
        })}
      </ul>

      {/* Next */}
      <Link to={nextLoc}>
        <ChevronRightIcon className="w-8 h-w-8 text-sky" />
      </Link>
    </div>
  );
}

Navigation.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
};

export default Navigation;
